import { ConversationsPanel } from "@/components/ConversationsPanel";
import { MessagesSquare } from "lucide-react";

export default function ForetagMeddelanden() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="font-head text-3xl font-bold flex items-center gap-2"><MessagesSquare className="h-7 w-7 text-primary" /> Meddelanden</h1>
        <p className="text-muted-foreground mt-2 max-w-2xl">När en kandidat godkänt din kontaktförfrågan öppnas en konversation här. Du ser bara kandidatens HAMN-id tills hen själv väljer att dela sina uppgifter.</p>
      </div>
      <ConversationsPanel canRequestReferences emptyText="Inga konversationer ännu. Skicka en kontaktförfrågan från Sök kandidater för att komma igång." />
    </div>
  );
}
